export const messages = {
  title: {
    id: "featured-carousel.title",
    defaultMessage: "Recommended for you",
  },
};
